import { Component, ElementRef, inject, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";

import { DrugDetails } from "../../../entities/drug";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { DrugsService } from "../../../services/drugs.service";
import { DrugInstitute } from "../../../entities/pharmacy/drug-institute";
import { MatTooltip } from "@angular/material/tooltip";
import { NgxTolgeeModule } from "@tolgee/ngx";

@Component({
	selector: "app-drug-details",
	imports: [
		MatDialogTitle,
		MatIconModule,
		MatDialogContent,
		MatButtonModule,
		MatDialogClose,
		MatExpansionModule,
		MatTooltip,
		NgxTolgeeModule,
	],
	templateUrl: "./drug-details.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: "./drug-details.component.scss",
})
export class DrugDetailsComponent {
	drugInstitute = inject<DrugInstitute>(MAT_DIALOG_DATA);
	private drugService = inject(DrugsService);

	contraindications: string[] = [];
	drugDetails: DrugDetails = { indications: "", posologies: "" };

	@ViewChild("indicationsInner") indicationsInner!: ElementRef<HTMLElement>;
	@ViewChild("indicationsContent") indicationsContent!: ElementRef<HTMLElement>;
	@ViewChild("contraindicationsInner") contraindicationsInner!: ElementRef<HTMLElement>;
	@ViewChild("contraindicationsContent") contraindicationsContent!: ElementRef<HTMLElement>;
	@ViewChild("posologiesInner") posologiesInner!: ElementRef<HTMLElement>;
	@ViewChild("posologiesContent") posologiesContent!: ElementRef<HTMLElement>;

	expanded = { indications: false, contraindications: false, posologies: false };
	hasMore = { indications: false, contraindications: false, posologies: false };

	toggle(section: keyof typeof this.expanded) {
		this.expanded[section] = !this.expanded[section];
	}

	private checkOverflow(inner: ElementRef<HTMLElement>, outer: ElementRef<HTMLElement>): boolean {
		return inner.nativeElement.scrollHeight > outer.nativeElement.clientHeight;
	}

	constructor() {
		const drugInstitute = this.drugInstitute;

		this.drugService.getContraindications(drugInstitute.drug.identifiers["vmpId"]).subscribe({
			next: (response) => {
				this.contraindications = response.contraindications;
				setTimeout(() => {
					this.hasMore.contraindications = this.checkOverflow(
						this.contraindicationsInner,
						this.contraindicationsContent
					);
				});
			},
		});
		this.drugService.getDrugDetails(drugInstitute.drug.identifiers["vidalId"]).subscribe({
			next: (response) => {
				this.drugDetails = response;
				setTimeout(() => {
					this.hasMore.indications = this.checkOverflow(this.indicationsInner, this.indicationsContent);
					this.hasMore.posologies = this.checkOverflow(this.posologiesInner, this.posologiesContent);
				});
			},
		});
	}
}
